import { createRouter, createWebHashHistory } from 'vue-router'
import store  from '@/store'
import service from '@/utils/request'
import { saveLoginRedirectUrl } from '@/utils/utils'
import laborRouter from './laborRouter'
export const routes = [
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/login.vue')
  },
  {
    path: '/miniprogram/approvalWebview',
    name: 'MiniprogramApprovalWebview',
    component: () => import ('@/views/miniprogram/miniprogram.vue')
  },
  {
    path: '/personnelField/scanCodeForm',
    name: 'scanCodeForm',
    component: () => import('@/views/personnelField/scanCodeForm.vue')
  },
  {
    path: '/asset/qrcodeDetail',
    name: 'qrcodeDetail',
    component: () => import('@/page/assetManagement/qrcodeDetail.vue')
  },
  {
    path: '/personnelField/scan',
    name: 'scan',
    component: () => import('@/views/personnelField/scan.vue'),
  },
  {
    path: '/personnelField/scanCodeFormSuccessfully',
    name: 'scanCodeFormSuccessfully',
    component: () => import('@/views/personnelField/scanCodeFormSuccessfully.vue')
  },
  {
   path: '/index',
   name: 'Index',
   component: () => import('@/views/index/index.vue')
 },
  {
    path: '/staging',
    name: 'Staging',
    component: () => import('@/views/home/index.vue'),
    redirect: to => {
      const redirectPath = localStorage.getItem('redirectPath') || '/index'
      return redirectPath
    },
    children:[
      {
        path: '/workbetch',
        name: 'Workbetch',
        component: () => import("@/views/home/workbetch.vue"),
      },
      {
        path: '/user/enterprise',
        name: 'UserEnterprise',
        component: () => import("@/views/user/enterprise.vue"),
      },
      {
        path: '/user/info',
        name: 'UserInfo',
        component: () => import("@/views/user/info.vue"),
      },
      {
        path: '/approval',
        name: 'Approval',
        component: () => import('@/views/wflow/admin/FormProcessDesigner.vue')
      },
      {
        path: '/management',
        name: 'Management',
        component: () => import("@/views/management/management.vue"),
        children: [
          
          {
            path: '/role/management',
            name: 'RoleManagement',
            component: () => import("@/views/management/role.vue")
          },
          {
            path: '/organizational/structure',
            name: 'OrganizationalStructure',
            component: () => import("@/views/organizational/structure.vue")
          },
          {
            path: '/user/management',
            name: 'UserManagement',
            component: () => import('@/views/user/management.vue')
          },
          {
            path: '/unit/management',
            name: 'UnitManagement',
            component: () => import('@/views/unit/management.vue')
          },
          {
            path: '/application/management',
            name: 'ApplicationManagement',
            component: () => import('@/views/application/management.vue')
          },
          {
            path: '/jobNumber/management',
            name: 'JobNumberManagement',
            component: () => import('@/views/jobNumber/management.vue')
          },
          {
            path: '/operationLog/management',
            name: 'operationLogManagement',
            component: () => import('@/views/operationLog/management.vue')
          },
          {
            path: '/message/center',
            name: 'MessageCenter',
            component: () => import('@/views/message/center.vue')
          },
          {
            path: '/message/rules',
            name: 'MessageRules',
            component: () => import('@/views/message/rules.vue')
          },
          {
            path: '/message/test',
            name: 'MessageTest',
            component: () => import('@/views/message/test1.vue')
          },
          {
            path: '/notice/management',
            name: 'NoticeManagement',
            component: () => import('@/views/notice/management.vue')
          },
          {
            path: '/notice/received',
            name: 'NoticeReceived',
            component: () => import('@/views/notice/received.vue')
          },
          {
            path: '/personnel/assistant/home',
            name: 'PersonnelAssistantHome',
            component: () => import('@/views/personnel/home.vue')
          },
          // {
          //   path: '/personnel/assistant/roster',
          //   name: 'PersonnelAssistantRoster',
          //   component: () => import('@/views/personnel/roster.vue')
          // },
          {
            path: '/personnelField/personnelField',
            name: 'personnelField',
            component: () => import('@/views/personnelField/personnelField.vue')
          },
          {
            path: '/personnelField/systemSalaryRating',
            name: 'systemSalaryRating',
            component: () => import('@/views/personnelField/systemSalaryRating.vue')
          },
          {
            path: '/personnelField/roster',
            name: 'roster',
            component: () => import('@/views/personnelField/roster.vue'),
            meta:{
              keepAlive: true
            }
          },{
            path: '/personnelField/rosterDetail/:id',
            name: 'rosterDetail',
            component: () => import('@/views/personnelField/rosterDetail.vue')
          },
          {
            path: '/personnelField/upload',
            name: 'upload',
            component: () => import('@/views/personnelField/upload.vue')
          },
          {
            path: '/personnelField/addEmployInfo/:id',
            name: 'addEmployInfo',
            component: () => import('@/views/personnelField/addEmployInfo.vue')
          },
          // {
          //   path: '/personnel/assistant/addEmployInfo',
          //   name: 'PersonnelAssistantAddEmployInfo',
          //   component: () => import('@/views/personnel/addEmployInfo.vue')
          // },
          {
            path: '/personnel/assistant/enter',
            name: 'PersonnelAssistantEnter',
            component: () => import('@/views/personnel/enter.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/personnel/assistant/applyFull',
            name: 'PersonnelAssistantApplyFull',
            component: () => import('@/views/personnel/applyFull.vue'),
             meta:{
              keepAlive: true
            }
          },
          {
            path: '/personnel/assistant/dismission',
            name: 'PersonnelAssistantDismission',
            component: () => import('@/views/personnel/dismission.vue'),
             meta:{
              keepAlive: true
            }
          },
          {
            path: '/personnel/assistant/transaction',
            name: 'PersonnelAssistantTransaction',
            component: () => import('@/views/personnel/transaction.vue'),
             meta:{
              keepAlive: true
            }
          },
          {
            path: '/personnel/assistant/roster_import',
            name: 'PersonnelAssistantRosterImport',
            component: () => import('@/views/personnel/roster_import.vue')
          },
          {
            path: '/personnel/assistant/roster_import_detail/:id',
            name: 'PersonnelAssistantRosterImportDetail',
            component: () => import('@/views/personnel/importFileDetail.vue')
          },
          {
            path: '/personnel/assistant/quit_user_list',
            name: 'PersonnelAssistantQuitUserList',
            component: () => import('@/views/personnel/quit_user_list.vue')
          },
          {
            path: '/personnel/assistant/contract_ledger',
            name: 'PersonnelAssistantContractLedger',
            component: () => import('@/views/personnel/contract_ledger.vue')
          },
          // {
          //   path: '/personnel/assistant/detail/:id',
          //   name: 'PersonnelAssistantDetail',
          //   component: () => import('@/views/personnel/detail.vue')
          // },
          // {
          //   path: '/personnel/assistant/upload',
          //   name: 'PersonnelAssistantUpload',
          //   component: () => import('@/views/personnel/upload.vue')
          // },
          {
            path: '/account/association',
            name: 'AccountAssociation',
            component: () => import('@/views/enterpriseWechat/memoformat.vue')
          },
          {
            path: '/approval/process/management',
            name: 'ApprovalProcessManagement',
            component: () => import('@/views/approval/processManagement.vue')
          },
          {
            path: '/approval/ccmy',
            name: 'ApprovalCcmy',
            component: () => import('@/views/approval/ccmy.vue')
          },
          {
            path: '/approval/list',
            name: 'ApprovalList',
            component: () => import('@/views/approval/list.vue')
          },
          {
            path: '/approval/waiting/me',
            name: 'ApprovalWaitingMe',
            component: () => import('@/views/approval/waitingMe.vue')
          },
          {
            path: '/approval/processed',
            name: 'ApprovalProcessed',
            component: () => import('@/views/approval/processed.vue')
          },
          {
            path: '/approval/initated',
            name: 'ApprovalInitated',
            component: () => import('@/views/approval/initated.vue')
          },
          {
            path: '/approval/model',
            name: 'ApprovalModel',
            component: () => import('@/views/approval/model.vue')
          },
          {
            path: '/approval/role',
            name: 'ApprovalRole',
            component: () => import('@/views/approval/role.vue')
          },
          {
            path: '/attendance/class/management',
            name: 'AttendanceClassManagement',
            component: () => import('@/views/attendance/class/management.vue')
          },
          {
            path: '/attendance/rules',
            name: 'AttendanceRules',
            component: () => import('@/views/attendance/holidays/rules.vue')
          },
          {
            path: '/attendance/team',
            name: 'AttendanceTeam',
            component: () => import('@/views/attendance/team/team.vue')
          },
          {
            path: '/attendance/schedule/fixed',
            name: 'AttendanceScheduleFixed',
            component: () => import('@/views/attendance/schedule/fixed.vue')
          },
          {
            path: '/attendance/schedule/unFixed',
            name: 'AttendanceScheduleUnFixed',
            component: () => import('@/views/attendance/schedule/unFixed.vue')
          },
          {
            path: '/attendance/report',
            name: 'AttendanceReport',
            component: () => import('@/views/attendance/report/report.vue'),
          },
          {
            path: '/attendance/user/scheduling',
            name: 'AttendanceUserScheduling',
            component: () => import('@/views/attendance/user/scheduling.vue'),
          },
          {
            path: '/attendance/abnormal',
            name: 'AttendanceAbnormal',
            component: () => import('@/views/attendance/abnormal/abnormal.vue'),
          },
          {
            path: '/attendance/mine',
            name: 'AttendanceMine',
            component: () => import('@/views/attendance/mine/mine.vue'),
          },
          {
            path: '/attendance/statistics',
            name: 'AttendanceStatistics',
            component: () => import('@/views/attendance/statistics/statistics.vue'),
          },
          {
            path: '/:catchAll(.*)',
            name: 'NotFound',
            component: () => import('@/views/not/found.vue')
          },
          {
            path: '/salaryCalculation/employeeCompensation',
            name: 'employeeCompensation',
            component: () => import('@/views/salaryCalculation/employeeCompensation.vue')
          },
          {
            path: '/salaryCalculation/employeeCompensationDetail/:id',
            name: 'employeeCompensationDetail',
            component: () => import('@/views/salaryCalculation/employeeCompensationDetail.vue')
          },
          {
            path: '/salaryCalculation/payrollGeneration',
            name: 'payrollGeneration',
            component: () => import('@/views/salaryCalculation/payrollGeneration.vue')
          },
          {
            path: '/salaryCalculation/payrollGenerationDetail/:id',
            name: 'payrollGenerationDetail',
            component: () => import('@/views/salaryCalculation/payrollGenerationDetail.vue')
          },
          {
            path: '/salaryCalculation/SalaryCompositionImport',
            name: 'SalaryCompositionImport',
            component: () => import('@/views/salaryCalculation/SalaryCompositionImport.vue')
          },
          {
            path: '/WorkforceManagement/SchedulingRecord',
            name: 'SchedulingRecord',
            component: () => import('@/views/WorkforceManagement/SchedulingRecord.vue')
          },
            {
            path: '/WorkforceManagement/StatutoryHoliday',
            name: 'StatutoryHoliday',
            component: () => import('@/views/WorkforceManagement/StatutoryHoliday.vue')
          },
          {
            path: '/AssessmentManagement/AssessmentRecords',
            name: 'AssessmentRecords',
            component: () => import('@/views/AssessmentManagement/AssessmentRecords.vue')
          },
          {
            path: '/salarySystem/salaryList',
            name: 'salaryList',
            component: () => import('@/views/salarySystem/salaryPayingUnit/salaryList.vue')
          },
          {
            path: '/salarySystem/salaryDetails/:id',
            name: 'salaryDetails',
            component: () => import('@/views/salarySystem/salaryPayingUnit/salaryDetails.vue')
          },
          {
            path: '/salarySystem/permission',
            name: 'permission',
            component: () => import('@/views/salarySystem/financial/permission.vue')
          },
          {
            path: '/salarySystem/relatedRoles/:id',
            name: 'relatedRoles',
            component: () => import('@/views/salarySystem/financial/relatedRoles.vue')
          },
          {
            path: '/salarySystem/accountOnline',
            name: 'accountOnline',
            component: () => import('@/views/salarySystem/financial/accountOnline.vue')
          },
          {
            path: '/salarySystem/accountManagement',
            name: 'accountManagement',
            component: () => import('@/views/salarySystem/financial/accountManagement.vue')
          },
          {
            path: '/salarySystem/accountManagementDetails/:id',
            name: 'accountManagementDetails',
            component: () => import('@/views/salarySystem/financial/accountManagementDetails.vue')
          },
          {
            path: '/salarySystem/oneClickPayrollList',
            name: 'oneClickPayrollList',
            component: () => import('@/views/salarySystem/oneClickPayroll/oneClickPayrollList.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/salarySystem/IntelligentUpload/:id',
            name: 'IntelligentUpload',
            component: () => import('@/views/salarySystem/oneClickPayroll/IntelligentUpload.vue')
          },
          {
            path: '/salarySystem/oneClickPayrollDetails/:id',
            name: 'oneClickPayrollDetails',
            component: () => import('@/views/salarySystem/oneClickPayroll/oneClickPayrollDetails.vue')
          },
          {
            path: '/salarySystem/flexibleSalaryList',
            name: 'flexibleSalaryList',
            component: () => import('@/views/salarySystem/flexibleSalary/flexibleSalaryList.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/salarySystem/flexIntelligentUpload/:id',
            name: 'flexIntelligentUpload',
            component: () => import('@/views/salarySystem/flexibleSalary/flexIntelligentUpload.vue')
          },
          {
            path: '/salarySystem/flexibleSalaryListDetails/:id',
            name: 'flexibleSalaryListDetails',
            component: () => import('@/views/salarySystem/flexibleSalary/flexibleSalaryListDetails.vue')
          },
          {
            path: '/salarySystem/abnormalVoucherList/:id',
            name: 'abnormalVoucherList',
            component: () => import('@/views/salarySystem/voucherDownload/abnormalVoucherList.vue')
          },
          {
            path: '/salarySystem/voucherDownloadList',
            name: 'voucherDownloadList',
            component: () => import('@/views/salarySystem/voucherDownload/voucherDownloadList.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/salarySystem/employingUnitsStatistics',
            name: 'employingUnitsStatistics',
            component: () => import('@/views/salarySystem/statistics/employingUnitsStatistics.vue')
          },
          {
            path: '/salarySystem/flexiblePayrollStatistics',
            name: 'flexiblePayrollStatistics',
            component: () => import('@/views/salarySystem/statistics/flexiblePayrollStatistics.vue')
          },
          {
            path: '/salarySystem/oneClickPayrollStatistics',
            name: 'oneClickPayrollStatistics',
            component: () => import('@/views/salarySystem/statistics/oneClickPayrollStatistics.vue')
          },
          {
            path: '/salarySystem/salarySystemIndex',
            name: 'salarySystemIndex',
            component: () => import('@/views/salarySystem/index/salarySystemIndex.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/salarySystem/salarySystemSearch/:id',
            name: 'salarySystemSearch',
            component: () => import('@/views/salarySystem/index/salarySystemSearch.vue')
          },
          {
            path: '/salarySystem/capitalFlow/:id',
            name: 'capitalFlow',
            component: () => import('@/views/salarySystem/index/capitalFlow.vue')
          },
          {
            path: '/salarySystem/salarySettlement',
            name: 'salarySettlement',
            component: () => import('@/views/salarySystem/financial/salarySettlement.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/salarySystem/cardEffectVerification',
            name: 'cardEffectVerification',
            component: () => import('@/views/salarySystem/cardEffectVerification/cardEffectVerification.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/salarySystem/addCardEffect/:id',
            name: 'addCardEffect',
            component: () => import('@/views/salarySystem/cardEffectVerification/addCardEffect.vue')
          },
          {
            path: '/salarySystem/cardEffectDetails/:id',
            name: 'cardEffectDetails',
            component: () => import('@/views/salarySystem/cardEffectVerification/cardEffectDetails.vue')
          },
          {
            path: '/personalDeclare/personalDeclareList',
            name: 'personalDeclareList',
            component: () => import('@/views/personalDeclare/personalDeclareList.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/personalDeclare/uploadPersonalDeclare/:id',
            name: 'uploadPersonalDeclare',
            component: () => import('@/views/personalDeclare/uploadPersonalDeclare.vue')
          },
          {
            path: '/personalDeclare/personalDeclareDetails/:id',
            name: 'personalDeclareDetails',
            component: () => import('@/views/personalDeclare/personalDeclareDetails.vue')
          },
          {
            path: '/personalTncomeTax/personalTncomeTaxList',
            name: 'personalTncomeTaxList',
            component: () => import('@/views/personalTncomeTax/personalTncomeTaxList.vue'),
            meta:{
              keepAlive: true
            }
          },
           {
            path: '/personalTncomeTax/uploadPersonalTncomeTax/:id',
            name: 'uploadPersonalTncomeTax',
            component: () => import('@/views/personalTncomeTax/uploadPersonalTncomeTax.vue')
          },
          {
            path: '/personalTncomeTax/personalTncomeTaxDetails/:id',
            name: 'personalTncomeTaxDetails',
            component: () => import('@/views/personalTncomeTax/personalTncomeTaxDetails.vue')
          },
          {
            path: '/socialSecurity/insuredStaff',
            name: 'insuredStaff',
            component: () => import('@/views/socialSecurity/insuredStaff/insuredStaff.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/socialSecurity/insuredStaffDetails/:id',
            name: 'insuredStaffDetails',
            component: () => import('@/views/socialSecurity/insuredStaff/insuredStaffDetails.vue')
          },
          {
            path: '/socialSecurity/insuredStaffRecords/:id',
            name: 'insuredStaffRecords',
            component: () => import('@/views/socialSecurity/insuredStaff/insuredStaffRecords.vue')
          },
          {
            path: '/socialSecurity/addBatch/:id',
            name: 'addBatch',
            component: () => import('@/views/socialSecurity/insuredStaff/addBatch.vue')
          },
          {
            path: '/socialSecurity/insuredStop',
            name: 'insuredStop',
            component: () => import('@/views/socialSecurity/insuredStop/insuredStop.vue'),
            meta:{
              keepAlive: true
            }
          },
        
          {
            path: '/socialSecurity/insuredScheme',
            name: 'insuredScheme',
            component: () => import('@/views/socialSecurity/insuredScheme/insuredScheme.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/socialSecurity/insuredSchemeEdit/:id',
            name: 'insuredSchemeEdit',
            component: () => import('@/views/socialSecurity/insuredScheme/insuredSchemeEdit.vue')
          },
          {
            path: '/socialSecurity/addInsuredScheme/:id',
            name: 'addInsuredScheme',
            component: () => import('@/views/socialSecurity/insuredScheme/addInsuredScheme.vue')
          },
          {
            path: '/socialSecurity/monthlStatement',
            name: 'monthlStatement',
            component: () => import('@/views/socialSecurity/monthlStatement/monthlStatement.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/socialSecurity/monthlStatementDetails/:id',
            name: 'monthlStatementDetails',
            component: () => import('@/views/socialSecurity/monthlStatement/monthlStatementDetails.vue')
          },
          {
            path: '/socialSecurity/solutionConfiguration',
            name: 'solutionConfiguration',
            component: () => import('@/views/socialSecurity/solutionConfiguration/solutionConfiguration.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/IntelligentSalary/salaryFile',
            name: 'salaryFile',
            component: () => import('@/views/IntelligentSalary/salaryFile/salaryFile.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/IntelligentSalary/salaryFileDetails/:id',
            name: 'salaryFileDetails',
            component: () => import('@/views/IntelligentSalary/salaryFile/salaryFileDetails.vue')
          },
          {
            path: '/IntelligentSalary/salaryEntryPatchSalary/:id',
            name: 'salaryEntryPatchSalary',
            component: () => import('@/views/IntelligentSalary/salaryFile/salaryEntryPatchSalary.vue')
          },
          {
            path: '/IntelligentSalary/salaryEntrySalary/:id',
            name: 'salaryEntrySalary',
            component: () => import('@/views/IntelligentSalary/salaryFile/salaryEntrySalary.vue')
          },
          {
            path: '/IntelligentSalary/salaryCalculation',
            name: 'salaryCalculation',
            component: () => import('@/views/IntelligentSalary/salaryCalculation/salaryCalculation.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/IntelligentSalary/payrollCalculation',
            name: 'payrollCalculation',
            component: () => import('@/views/IntelligentSalary/salaryCalculation/payrollCalculation.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/IntelligentSalary/nowSalary/:id',
            name: 'nowSalary',
            component: () => import('@/views/IntelligentSalary/salaryCalculation/nowSalary.vue')
          },
          {
            path: '/IntelligentSalary/salaryComputeHistory/:id',
            name: 'salaryComputeHistory',
            component: () => import('@/views/IntelligentSalary/salaryCalculation/salaryComputeHistory.vue')
          },
          {
            path: '/IntelligentSalary/calculateSalaryDetail/:id',
            name: 'calculateSalaryDetail',
            component: () => import('@/views/IntelligentSalary/salaryCalculation/calculateSalaryDetail.vue')
          },
          {
            path: '/IntelligentSalary/salarySearchDetail/:id',
            name: 'salarySearchDetail',
            component: () => import('@/views/IntelligentSalary/salaryCalculation/salarySearchDetail.vue')
          },
          {
            path: '/IntelligentSalary/createSalaryRule/:id',
            name: 'createSalaryRule',
            component: () => import('@/views/IntelligentSalary/salaryCalculation/createSalaryRule.vue')
          },
          {
            path: '/IntelligentSalary/editSalaryRule/:id',
            name: 'editSalaryRule',
            component: () => import('@/views/IntelligentSalary/salaryCalculation/editSalaryRule.vue')
          },
          {
            path: '/IntelligentSalary/calculateSalaryEdit/:id',
            name: 'calculateSalaryEdit',
            component: () => import('@/views/IntelligentSalary/salaryCalculation/calculateSalaryEdit.vue')
          },
          {
            path: '/IntelligentSalary/calculateSalaryUpload/:id',
            name: 'calculateSalaryUpload',
            component: () => import('@/views/IntelligentSalary/salaryCalculation/calculateSalaryUpload.vue')
          },
          {
            path: '/IntelligentSalary/salaryInquiry',
            name: 'salaryInquiry',
            component: () => import('@/views/IntelligentSalary/salaryInquiry/salaryInquiry.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/IntelligentSalary/monthlySummary',
            name: 'monthlySummary',
            component: () => import('@/views/IntelligentSalary/salaryInquiry/monthlySummary.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/IntelligentSalary/monthlySummaryDetails/:id',
            name: 'monthlySummaryDetails',
            component: () => import('@/views/IntelligentSalary/salaryInquiry/monthlySummaryDetails.vue'),
           
          },
          {
            path: '/IntelligentSalary/salaryInquiryDetails/:id',
            name: 'salaryInquiryDetails',
            component: () => import('@/views/IntelligentSalary/salaryInquiry/salaryInquiryDetails.vue')
          },
          {
            path: '/IntelligentSalary/salaryItemSettings',
            name: 'salaryItemSettings',
            component: () => import('@/views/IntelligentSalary/salaryItemSettings/salaryItemSettings.vue')
          },
          {
            path: '/IntelligentSalary/dataSummaryList',
            name: 'dataSummaryList',
            component: () => import('@/views/IntelligentSalary/dataSummary/dataSummaryList.vue')
          },
          {
            path: '/IntelligentSalary/dataSummaryDetails/:id',
            name: 'dataSummaryDetails',
            component: () => import('@/views/IntelligentSalary/dataSummary/dataSummaryDetails.vue'),
           
          },
          {
            path: '/IntelligentSalary/importFile',
            name: 'importFile',
            component: () => import('@/views/IntelligentSalary/importFile/importFile.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/IntelligentSalary/uploadFile/:id',
            name: 'uploadFile',
            component: () => import('@/views/IntelligentSalary/importFile/uploadFile.vue'),
          },
          {
            path: '/IntelligentSalary/importFileDetails/:id',
            name: 'importFilDetails',
            component: () => import('@/views/IntelligentSalary/importFile/importFileDetails.vue')
          },
          {
            path: '/hire/TalentPoolList',
            name: 'TalentPoolList',
            component: () => import('@/views/hire/TalentPool/TalentPoolList.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/hire/TalentImport/:id',
            name: 'TalentImport',
            component: () => import('@/views/hire/TalentPool/TalentImport.vue'),
          },
          {
            path: '/hire/TalentDetails/:id',
            name: 'TalentDetails',
            component: () => import('@/views/hire/TalentPool/TalentDetails.vue'),
          },
          {
            path: '/hire/TalentPoolBatchList',
            name: 'TalentPoolBatchList',
            component: () => import('@/views/hire/TalentPoolBatch/TalentPoolBatchList.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/hire/TalentPoolBatchImport',
            name: 'TalentPoolBatchImport',
            component: () => import('@/views/hire/TalentPoolBatch/TalentPoolBatchImport.vue'),
          },
          {
            path: '/hire/TalentPoolBatchDetails/:id',
            name: 'TalentPoolBatchDetails',
            component: () => import('@/views/hire/TalentPoolBatch/TalentPoolBatchDetails.vue'),
          },
          {
            path: '/basicInformation/businessType',
            name: 'businessType',
            component: () => import('@/views/basicInformation/businessType.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/basicInformation/contractingEntity',
            name: 'contractingEntity',
            component: () => import('@/views/basicInformation/contractingEntity/contractingEntityList.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/IntelligentSalary/contractingEntityEdit/:id',
            name: 'contractingEntityEdit',
            component: () => import('@/views/basicInformation/contractingEntity/contractingEntityEdit.vue')
          },
          {
            path: '/basicInformation/contractingEntityDetails/:id',
            name: 'contractingEntityDetails',
            component: () => import('@/views/basicInformation/contractingEntity/contractingEntityDetails.vue')
          },
          {
            path: '/basicInformation/applicationList',
            name: 'applicationList',
            component: () => import('@/views/basicInformation/applicationList/applicationList.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/basicInformation/applicationEdit/:id',
            name: 'applicationEdit',
            component: () => import('@/views/basicInformation/applicationList/applicationEdit.vue')
          },
          {
            path: '/basicInformation/applicationDetails/:id',
            name: 'applicationDetails',
            component: () => import('@/views/basicInformation/applicationList/applicationDetails.vue')
          },
          {
            path: '/basicInformation/corporateClient',
            name: 'corporateClient',
            component: () => import('@/views/basicInformation/corporateClient.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/basicInformation/auxiliaryDataConfiguration',
            name: 'auxiliaryDataConfiguration',
            component: () => import('@/views/basicInformation/auxiliaryDataConfiguration/auxiliaryDataConfiguration.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/basicInformation/customerDetailsTable',
            name: 'customerDetailsTable',
            component: () => import('@/views/basicInformation/customerDetailsTable.vue'),
            meta:{
              keepAlive: true
            }
          },
           {
            path: '/basicInformation/addCustomerDetailsTable/:id',
            name: 'addCustomerDetailsTable',
            component: () => import('@/views/basicInformation/addCustomerDetailsTable.vue')
          },
           {
            path: '/basicInformation/customerDetailsTableFile',
            name: 'customerDetailsTableFile',
            component: () => import('@/views/basicInformation/customerDetailsTableFile.vue'),
            meta:{
              keepAlive: false
            }
          },
          {
            path: '/basicInformation/customer',
            name: 'customer',
            component: () => import('@/views/basicInformation/customer.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/basicInformation/plantArea',
            name: 'plantArea',
            component: () => import('@/views/basicInformation/plantArea/plantArea.vue'),
            meta:{
              keepAlive: true
            }
          },
           {
            path: '/basicInformation/Addbusiness/:id',
            name: 'Addbusiness',
            component: () => import('@/views/basicInformation/plantArea/Addbusiness.vue'),
         
          },
          {
            path: '/basicInformation/project',
            name: 'project',
            component: () => import('@/views/basicInformation/project/projectList.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/basicInformation/projectUploadFile',
            name: 'projectUploadFile',
            component: () => import('@/views/basicInformation/project/projectUploadFile.vue'),
            meta:{
              keepAlive: false
            }
          },
          {
            path: '/basicInformation/personnel/contract',
            name: '人员合同',
            component: () => import('@/views/basicInformation/personnel/contract.vue'),
            meta:{
              keepAlive: true
            }
          },
          {
            path: '/project/projectProposal/:id',
            name: 'projectProposal',
            component: () => import('@/views/basicInformation/project/projectProposal.vue')
          },
          {
            path: '/basicInformation/projectContract',
            name: 'projectContract',
            component: () => import('@/views/basicInformation/projectContract.vue'),
          },
          {
            path: '/basicInformation/operatingDocs',
            name: 'operatingDocs',
            component: () => import('@/views/basicInformation/operatingDocs.vue'),
          },
          {
            path: '/outsourcedProject/projectManagement',
            name: 'projectManagement',
            component: () => import('@/views/outsourcedProject/projectManagement.vue'),
          },
          {
            path: '/merchantStatistics/merchantReport',
            name: 'merchantReport',
            component: () => import('@/views/merchantStatistics/merchantReport.vue'),
          },
          {
            path: '/merchantStatistics/merchantReportAll',
            name: 'merchantReportAll',
            component: () => import('@/views/merchantStatistics/merchantReportAll.vue'),
          },
          
          ...laborRouter,
        ]
      },
    ]
  },
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

let isLoading = false

const findNodeByUri = (tree, targetUri) => {
  // 检查当前节点是否匹配
  if (tree.uri === targetUri) return tree;

  // 递归检查子节点
  if (tree._child?.length) {
    for (const child of tree._child) {
      const found = findNodeByUri(child, targetUri);
      if (found) return found;
    }
  }

  return null; // 未找到
}

router.beforeEach(async (to, from, next) => {
  const token = localStorage.getItem('token');
  if (token) {
    if (to.path == '/login' || to.path == '/') {
      next('/staging')
    }else if(to.path == '/staging' || to.path == '/workbetch'){
      store.dispatch('app_id','')
      next()
    } else {
      if(to.path != '/management'){
        let res
        // if(store.state.isMenuLoaded === false){
        res = await service({
          method:'post',
          url: 'merchant/v2/basic/get_menu_by_url',
          data: {
            url: to.path
          }
        })
        let app_idNew=Number(localStorage.getItem('app_id'))
        let activeIndexNew=localStorage.getItem('activeIndex')
        await store.dispatch('app_id',res?.data.app_id || app_idNew)
        await store.dispatch('activeIndex',String(res?.data.id || activeIndexNew))
        next()
      }else if(to.path == '/management'){
        next()
      }
    }
  } else {
    if (to.path == '/login') {
      next();
    } else {
      if(to.path == '/personnelField/scanCodeForm' ||to.path == '/personnelField/scan'|| to.path == '/miniprogram/approvalWebview' || to.path == '/personnelField/scanCodeFormSuccessfully'|| to.path == '/asset/qrcodeDetail' ){
        next();
      }else{
        // 未登录直接访问具体菜单链接时，记录该地址，登录成功后跳回该菜单
        saveLoginRedirectUrl(`${window.location.origin}${window.location.pathname}#${to.fullPath}`)
        next('/login');
      }
       
    }
  }
});
export default router
